import { IFooterConfigAllwithDefault } from '../interface/IFooter';
import DataStore from "./DataStore";
import {makeEl} from "../common/Utils";
import Country from "./component/Country";
import Language from "./component/Language";
import SnsList from "./component/SnsList";
import Links from "./component/Links";
import Info from "./component/Info";
import Copyright from "./component/Copyright";
import Logo from "./component/Logo";
import FamilySite from "./component/FamilySite";
import Layer from "./Layer";
import LanguageCountry from './component/LanguageCountry';

export default class Index {
    constructor(_config: IFooterConfigAllwithDefault) {
        DataStore.instance.init(_config);
        const footerMain = document.querySelector<HTMLElement>('#footer');
        if(footerMain){
            const wrapper = makeEl('div', footerMain, {class: 'footer'})
            const changeWrap = makeEl('div', wrapper, {class: 'footer-change-wrap'})
            new Country(changeWrap);
            new Language(changeWrap);
            new LanguageCountry(changeWrap);
            new SnsList(wrapper);
            new Links(wrapper);
            new Info(wrapper);
            new Copyright(wrapper);
            new Logo(wrapper);
            new FamilySite(wrapper);
            new Layer();
        }
    }
} // end of class